export default "__VITE_ASSET__BCY4Cj2g__"